import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class PdfBatchGenerationService {
  constructor(private http: HttpClient) {}

  public fetchPdfBatchStats(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/pdfBatch/initGenerationStats`
    return this.http.get(url, params)
  }

  public fetchBatchTaskStatus(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/pdfBatch/generationJobStatus`
    return this.http.get(url, params)
  }

  public generatePdfBatch(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/pdfBatch/generate`
    return this.http.get(url, params)
  }

  public stopPdfBatchGeneration(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/pdfBatch/forceStop`
    return this.http.get(url, params)
  }
}
